import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// Config
import { IMAGE_BASE_URL, BACKDROP_SIZE, CARD_POSTER_SIZE } from '../../config';
// Helpers
import { getYear, formatRating } from '../../helpers';
// Styles
import { Wrapper, Feature, Text, UpNext } from './Hero.styles';

const Hero = ({ featured, upNext }) => (
  <Wrapper>
    <Feature
      $image={
        featured.backdrop_path
          ? `${IMAGE_BASE_URL}${BACKDROP_SIZE}${featured.backdrop_path}`
          : null
      }
    >
      <Text>
        <span className='eyebrow'>
          <b>№ 01</b> Most popular right now
        </span>
        <h1>{featured.title}</h1>
        <div className='meta'>
          {getYear(featured.release_date) && (
            <span>{getYear(featured.release_date)}</span>
          )}
          <span>★ {formatRating(featured.vote_average)}</span>
          {featured.vote_count ? (
            <span>{featured.vote_count.toLocaleString('en-US')} votes</span>
          ) : null}
        </div>
        <p>{featured.overview}</p>
        <Link to={`/${featured.id}`} className='cta'>
          View details <span aria-hidden='true'>→</span>
        </Link>
      </Text>
    </Feature>

    {upNext.length > 0 && (
      <UpNext aria-label='Also popular'>
        <h2>Also trending</h2>
        <ol>
          {upNext.map((movie, i) => (
            <li key={movie.id}>
              <Link to={`/${movie.id}`}>
                <span className='rank'>{String(i + 2).padStart(2, '0')}</span>
                {movie.poster_path ? (
                  <img
                    src={`${IMAGE_BASE_URL}${CARD_POSTER_SIZE}${movie.poster_path}`}
                    alt=''
                  />
                ) : (
                  <span className='noimg' />
                )}
                <span className='info'>
                  <strong>{movie.title}</strong>
                  <small>
                    {getYear(movie.release_date) || 'TBA'} · ★{' '}
                    {formatRating(movie.vote_average)}
                  </small>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </UpNext>
    )}
  </Wrapper>
);

Hero.propTypes = {
  featured: PropTypes.object.isRequired,
  upNext: PropTypes.array
};

export default Hero;
